import { ApplicationConfig, importProvidersFrom } from "@angular/core";
import {
  provideHttpClient,
  HTTP_INTERCEPTORS,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideRouter, withHashLocation } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { GoogleMapsModule } from "@angular/google-maps";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatSliderModule } from "@angular/material/slider";
import { MatTableModule } from "@angular/material/table";
import { MatInputModule } from "@angular/material/input";
import { MatSortModule } from "@angular/material/sort";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSidenavModule } from "@angular/material/sidenav";

import { routes } from "./app.routes";
import { AuthenticationGuard } from "./guards/authentication.guard";
import { TokenInterceptor } from "./interceptors/token.interceptor";

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideRouter(routes),
    importProvidersFrom(
      GoogleMapsModule,
      FormsModule,
      ReactiveFormsModule,
      MatSliderModule,
      MatTableModule,
      MatInputModule,
      MatSortModule,
      MatPaginatorModule,
      MatCheckboxModule,
      MatProgressSpinnerModule,
      MatSidenavModule,
    ),
    CookieService,
    AuthenticationGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
  ],
};
